import AuditLogsSlideOut from './AuditLogsSlideOut';

export default AuditLogsSlideOut;
